import React from 'react';
import Modal from '../../../../shared/modal';

interface IColumnPickerModal {
    openModal: boolean;
    columns?: any;
    onChangeActiveColumns: (columns: any, show: boolean) => void;
    handleCloseModal: () => void;
}

const ColumnPickerModal = ({
    openModal,
    columns,
    onChangeActiveColumns,
    handleCloseModal,
}: IColumnPickerModal) => {

    const onCloseModal = () => {
        handleCloseModal();
    };

    return (
        <Modal
            open={openModal}
            title='Columns Picker'
            headerStyle='border-b-1 py-3 mb-0'
            onClose={onCloseModal}
            contentContainerStyle='!rounded-xl min-w-[95%] md:min-w-[70%] lg:min-w-[50%]'>
            <div className='p-2 min-w-[95%] md:min-w-[70%] lg:min-w-[60%] min-h-[400px]'>
                <p className='text-primary-light dark:text-primary-dark mb-2'>Check or uncheck columns</p>
                <div className='grid grid-cols-1 md:grid-cols-2 gap-4'>
                    {(columns && columns?.length > 0) && columns?.map((item: any, idx: number) => {
                        return (
                            <div
                                key={idx}
                                onClick={() => onChangeActiveColumns(item, !item?.hide)}
                                className='mb-2 flex flex-row items-center cursor-pointer'>
                                <input
                                    type='checkbox'
                                    checked={!item?.hide}
                                    className='accent-[#252B37] dark:!accent-[#fff] w-4 h-4'
                                />
                                <p className='dark:text-primary-dark ml-3'>{item?.name}</p>
                            </div>
                        )
                    })}
                </div>
            </div>
        </Modal>
    );
};

export default ColumnPickerModal;